import { BodyText, Button, Callout, Label } from "@/components/ui";
import type { RequestGroup } from "@curai/js-fhir-tools";
import { useState } from "react";
import { PSCSearchModal } from "./PSC/PSCSearchModal";

export const PSCSelection = ({
  readOnly,
  needsPSCSelection,
  patientId,
  encounterId,
  requestGroup,
}: {
  readOnly: boolean;
  needsPSCSelection: boolean;
  patientId: string;
  encounterId: string;
  requestGroup: RequestGroup;
}) => {
  const [isPSCModalOpen, setIsPSCModalOpen] = useState(false);

  return (
    <div>
      {needsPSCSelection && (
        <Callout variant="warning" title="Collection Center Required">
          <div className="flex flex-col gap-2">
            <BodyText size="sm">
              A lab collection center near the patient could not be
              automatically determined. Search for a nearby collection center to
              add tests.
            </BodyText>
            <Button
              size="xs"
              variant="primary"
              className="w-fit h-6"
              onClick={() => setIsPSCModalOpen(true)}
              disabled={readOnly}
            >
              Find Collection Center
            </Button>
          </div>
        </Callout>
      )}
      {requestGroup.performingLocation && (
        <div className="flex flex-col gap-1">
          <Label>Collection Center</Label>
          <BodyText size="sm">
            {requestGroup.performingLocation.managingOrganization?.display}
          </BodyText>
          <BodyText size="sm">
            {requestGroup.performingLocation.address && (
              <BodyText size="sm">
                {requestGroup.performingLocation.address.city},{" "}
                {requestGroup.performingLocation.address.state}{" "}
                {requestGroup.performingLocation.address.postalCode}
              </BodyText>
            )}
          </BodyText>
          <Button
            size="xs"
            variant="secondary"
            className="w-fit"
            onClick={() => setIsPSCModalOpen(true)}
            disabled={readOnly}
          >
            Change Collection Center
          </Button>
        </div>
      )}

      {isPSCModalOpen && (
        <PSCSearchModal
          patientId={patientId}
          labNetwork={
            requestGroup.labNetwork as (typeof RequestGroup.LAB_NETWORKS)[keyof typeof RequestGroup.LAB_NETWORKS]
          }
          open={isPSCModalOpen}
          onOpenChange={setIsPSCModalOpen}
          requestGroupId={requestGroup.id as string}
          encounterId={encounterId}
        />
      )}
    </div>
  );
};
